CLASSIC_FACET_MEDITATION_DURATION